import "./assets/scss/custom-style.scss";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import AppContextProvider from "./context/AppContextProvider";
import PrivateRoutes from "./components/PrivateRoutes";

import Login from "./pages/Login";
import ChooseCompany from "./pages/Login/choose_company";
import HomePage from "./pages/Home";

import CompanyInformation from "./pages/MasterSAP/Company";
import CustomerInformation from "./pages/MasterSAP/Customer";
import EmployeeInformation from "./pages/MasterSAP/Employee";
import ProductInformation from "./pages/MasterSAP/Product";
import BranchInformation from "./pages/MasterSAP/Branch";
import EditBranchInformation from "./pages/MasterSAP/Branch/edit";

import ArchiveInformation from "./pages/Master/ArchiveView/Archive";
import PropertyInformation from "./pages/Master/ArchiveView/Property";
import StatusAndBalance from "./pages/Master/ArchiveView/StatusBalance";
import ProductPickedUpSuccessfully from "./pages/Master/ArchiveView/PickedUp";
import ProductReturnedSuccessfully from "./pages/Master/ArchiveView/Returned";

import BOMInformation from "./pages/Master/Main/BOM";
import AddBOMInformation from "./pages/Master/Main/BOM/create";
import EditBOMInformation from "./pages/Master/Main/BOM/edit";
import DeleteBOMInformation from "./pages/Master/Main/BOM/delete";
import CopyBOMInformation from "./pages/Master/Main/BOM/copy";
import OperatingProcedures from "./pages/Master/Main/operating";
import CreateOperatingProcedures from "./pages/Master/Main/operating/create";
import EditOperatingProcedures from "./pages/Master/Main/operating/edit";
import ServiceRequest from "./pages/Master/Main/request";
import AddServiceRequest from "./pages/Master/Main/request/create";
import EditServiceRequest from "./pages/Master/Main/request/edit";

import ServiceTypeInformation from "./pages/Master/General/ServiceType";
import AddServiceTypeInformation from "./pages/Master/General/ServiceType/create";
import EditServiceTypeInformation from "./pages/Master/General/ServiceType/edit";
import SetMachineType from "./pages/Master/General/MachineType";
import AddSetMachineType from "./pages/Master/General/MachineType/create";
import EditSetMachineType from "./pages/Master/General/MachineType/edit";
import AssignPrefixNumber from "./pages/Master/General/AssignNumber";
import AddAssignPrefixNumber from "./pages/Master/General/AssignNumber/create";
import EditAssignPrefixNumber from "./pages/Master/General/AssignNumber/edit";
import WorkOrderStatusInformation from "./pages/Master/General/WorkOrderStatus";
import AddWorkOrderStatusInformation from "./pages/Master/General/WorkOrderStatus/create";
import EditWorkOrderStatusInformation from "./pages/Master/General/WorkOrderStatus/edit";
import TechnicianTeamInformation from "./pages/Master/General/TechnicianTeam";
import FOCInformation from "./pages/Master/General/FOC";
import AddFOCInformation from "./pages/Master/General/FOC/create";
import EditFOCInformation from "./pages/Master/General/FOC/edit";
import ReasonInformation from "./pages/Master/General/Reason";
import AddReasonInformation from "./pages/Master/General/Reason/create";
import EditReasonInformation from "./pages/Master/General/Reason/edit";
import JobTypeInformation from "./pages/Master/General/JobType";
import AddJobTypeInformation from "./pages/Master/General/JobType/create";
import EditJobTypeInformation from "./pages/Master/General/JobType/edit";
import SetWarrantyPeriod from "./pages/Master/General/WarrantyPeriod";
import EditSetWarrantyPeriod from "./pages/Master/General/WarrantyPeriod/edit";
import AddSetWarrantyPeriod from "./pages/Master/General/WarrantyPeriod/create";

import MAServiceContract from "./pages/PMWork/MAService";
import ImportKeepFile from "./pages/PMWork/MAService/preview";
import AddMAServiceContract from "./pages/PMWork/MAService/create";
import EditMAServiceContract from "./pages/PMWork/MAService/edit";
import BindingPMServiceContract from "./pages/PMWork/BindPM";
import AddBindingPMServiceContract from "./pages/PMWork/BindPM/create";
import AddSubBindingPMServiceContract from "./pages/PMWork/BindPM/createsub";
import EditBindingPMServiceContract from "./pages/PMWork/BindPM/edit";
import DeleteBindingPMServiceContract from "./pages/PMWork/BindPM/delete";
import CopyBindingPMServiceContract from "./pages/PMWork/BindPM/copy";
import CreatePlanPM from "./pages/PMWork/CreatePlan";
import AddCreatePlanPM from "./pages/PMWork/CreatePlan/create.js";
import EditCreatePlanPM from "./pages/PMWork/CreatePlan/edit.js";
import PreviewCreatePlanPM from "./pages/PMWork/CreatePlan/preview.js";
import PlanPM from "./pages/PMWork/PlanPM";
import EditPlanPM from "./pages/PMWork/PlanPM/edit";
import AdjustPlan from "./pages/PMWork/AdjustPM";
import FollowPM from "./pages/PMWork/FollowPM";

import FollowStatusService from "./pages/GeneralJob/FollowStatus";
import CreateJobNotification from "./pages/GeneralJob/CreateJob";
import PreviewFileCreate from "./pages/GeneralJob/CreateJob/preview";
import EditWorkOrderStatus from "./pages/GeneralJob/CreateJob/edit.js";

import Installation from "./pages/InstallationWork/RecordDetail";
import PreviewCheckReceive from "./pages/InstallationWork/CheckReceive/preview.js";
import PreviewInstallationWork from "./pages/InstallationWork/RecordDetail/preview.js";
import CheckReceiveNotifications from "./pages/InstallationWork/CheckReceive";
import ReturnPropertyInstallationWorkOrder from "./pages/InstallationWork/ReturnProperty";
import ReturnPropertyInstallationWorkOrderDetail from "./pages/InstallationWork/ReturnProperty/detail.js";
import IssueInstallationWorkOrder from "./pages/InstallationWork/IssueInstallation";


import CheckCustomerHistory from "./pages/RepairWork/HistoryCustomer";
import PreviewRepairNotify from "./pages/RepairWork/HistoryCustomer/preview.js";
import RecordRepairNotification from "./pages/RepairWork/RecordRepair";
import PreviewRepairNotification from "./pages/RepairWork/RecordRepair/preview.js";
import IssueWorkOrderRepair from "./pages/RepairWork/IssueRepair";
import EditRepairWorkOrders from "./pages/RepairWork/IssueRepair/edit.js";
import PreviewRepairWorkOrder from "./pages/RepairWork/IssueRepair/preview.js";
import FollowRepairStatus from "./pages/RepairWork/FollowRepair";

import PerformServiceRequest from "./pages/ServiceWork/PerformService/index.js";
import DetailPerform from "./pages/ServiceWork/PerformService/detail.js";
import DataServiceReport from "./pages/ServiceWork/PerformService/Tabs/dataServiceReport.js";
import ReportPage from "./pages/ServiceWork/PerformService/report.js";

import ReturnEquipmentParts from "./pages/ServiceWork/ReturnEquipment";
import EditReturnEquipment from "./pages/ServiceWork/ReturnEquipment/edit.js";
import PreviewReturnEquipment from "./pages/ServiceWork/ReturnEquipment/preview.js";

import ExpensesDuringWork from "./pages/ServiceWork/ExpensesDuring";
import DeliveryDocuments from "./pages/ServiceWork/Delivery";
import EditDeliveryDocuments from "./pages/ServiceWork/Delivery/edit";

import HeadEventPlanning from "./pages/ServiceWork/HeadPlanning";
import EventPlanningDetail from "./pages/ServiceWork/HeadPlanning/Tabs/EventPlaningDetail";
import EditEventPlanningDetail from "./pages/ServiceWork/HeadPlanning/Tabs/Editplanfrom";
import ImportHeadEventPlanning from "./pages/ServiceWork/HeadPlanning/import";
import WorkCalendar from "./pages/ServiceWork/HeadPlanning/Tabs/calendars";
import PlanningPreview from "./pages/ServiceWork/HeadPlanning/preview";
import CheckeQuipment from "./pages/ServiceWork/HeadPlanning/check";

import JobAcceptanceTeam from "./pages/ServiceWork/JobAcceptance";
import TeamDetailEdit from "./pages/ServiceWork/JobAcceptance/Tabs/teamdetailedit";
import TeamPreview from "./pages/ServiceWork/JobAcceptance/preview";
import SummaryEquipment from "./pages/ServiceWork/JobAcceptance/equipment";
import ImportEquipment from "./pages/ServiceWork/JobAcceptance/import";
import PreviewEquipment from "./pages/ServiceWork/JobAcceptance/preview equip";
import ContactCustomer from "./pages/ServiceWork/JobAcceptance/contactcus";
import PageAddCustomer from "./pages/ServiceWork/JobAcceptance/add customer";
import EditCustomer from "./pages/ServiceWork/JobAcceptance/Tabs/editcustomer.js";
import PageCheckIn from "./pages/ServiceWork/JobAcceptance/checkin";

import RequestReimbursementRefund from "./pages/ReimbursementRefund";
import PreviewReimbursementRefund from "./pages/ReimbursementRefund/preview.js";

import Report from "./pages/Report";
import Administrator from "./pages/Admin";
import NotFound from "./pages/NotFound.js";
import AddExpense from "./pages/ServiceWork/ExpensesDuring/add.js";
import EditExpense from "./pages/ServiceWork/ExpensesDuring/edit.js";
import DetailCloseJob from "./pages/ServiceWork/PerformService/Tabs/detailCloseJob.js";
import AddDocument from "./pages/ServiceWork/Delivery/addDocument.js";
import AddReport from "./pages/ServiceWork/PerformService/addReport.js";
import PreviewReportPage from "./pages/ServiceWork/PerformService/Tabs/previewReport.js";
import EditReport from "./pages/ServiceWork/PerformService/editReport.js";

function App() {
  return (
    <BrowserRouter>
      <AppContextProvider>
        <HelmetProvider>
          <Helmet>
            <title>Filter-Vision</title>
            <meta name="description" content="Filter Vision application" />
          </Helmet>

          <Routes>
            <Route element={<PrivateRoutes />}>
              <Route element={<ChooseCompany />} path="/choose_company" />

              <Route element={<Navigate to="/home" />} path="/" exact />
              <Route element={<HomePage />} path="/home" />

              <Route path="/sap_master">
                <Route element={<CompanyInformation />} path="company" />
                <Route element={<CustomerInformation />} path="customer" />
                <Route path="branch">
                  <Route element={<BranchInformation />} index />
                  <Route element={<EditBranchInformation />} path=":id" />
                </Route>
                <Route element={<ProductInformation />} path="product" />
                <Route element={<EmployeeInformation />} path="employee" />
              </Route>

              <Route path="/wo_master">
                <Route path="service_type">
                  <Route element={<ServiceTypeInformation />} index />
                  <Route
                    element={<AddServiceTypeInformation />}
                    path="create"
                  />
                  <Route element={<EditServiceTypeInformation />} path=":id" />
                </Route>
                <Route path="machine_type">
                  <Route element={<SetMachineType />} index />
                  <Route element={<AddSetMachineType />} path="create" />
                  <Route element={<EditSetMachineType />} path=":id" />
                </Route>
                <Route path="assign_prefix">
                  <Route element={<AssignPrefixNumber />} index />
                  <Route element={<AddAssignPrefixNumber />} path="create" />
                  <Route element={<EditAssignPrefixNumber />} path=":id" />
                </Route>
                <Route path="work_order_status">
                  <Route element={<WorkOrderStatusInformation />} index />
                  <Route
                    element={<AddWorkOrderStatusInformation />}
                    path="create"
                  />
                  <Route
                    element={<EditWorkOrderStatusInformation />}
                    path=":id"
                  />
                </Route>
                <Route path="technican_team">
                  <Route element={<TechnicianTeamInformation />} index />
                </Route>

                <Route path="FOC">
                  <Route element={<FOCInformation />} index />
                  <Route element={<AddFOCInformation />} path="create" />
                  <Route element={<EditFOCInformation />} path=":id" />
                </Route>
                <Route path="reason">
                  <Route element={<ReasonInformation />} index />
                  <Route element={<AddReasonInformation />} path="create" />
                  <Route element={<EditReasonInformation />} path=":id" />
                </Route>
                <Route path="BOM">
                  <Route element={<BOMInformation />} index />
                  <Route element={<AddBOMInformation />} path="create" />
                  <Route element={<EditBOMInformation />} path="edit" />
                  <Route element={<DeleteBOMInformation />} path="delete" />
                  <Route element={<CopyBOMInformation />} path="copy" />
                </Route>
                <Route path="operating">
                  <Route element={<OperatingProcedures />} index />
                  <Route
                    element={<CreateOperatingProcedures />}
                    path="create"
                  />
                  <Route element={<EditOperatingProcedures />} path=":id" />
                </Route>
                <Route path="request">
                  <Route element={<ServiceRequest />} index />
                  <Route element={<AddServiceRequest />} path="create" />
                  <Route element={<EditServiceRequest />} path=":id" />
                </Route>
                <Route path="job_type">
                  <Route element={<JobTypeInformation />} index />
                  <Route element={<AddJobTypeInformation />} path="create" />
                  <Route element={<EditJobTypeInformation />} path=":id" />
                </Route>
                <Route path="warranty_period">
                  <Route element={<SetWarrantyPeriod />} index />
                  <Route element={<AddSetWarrantyPeriod />} path="create" />
                  <Route element={<EditSetWarrantyPeriod />} path=":id" />
                </Route>
              </Route>

              <Route path="/archive_view">
                <Route element={<ArchiveInformation />} path="archive" />
                <Route element={<PropertyInformation />} path="property" />
                <Route element={<StatusAndBalance />} path="status_balance" />
                <Route
                  element={<ProductPickedUpSuccessfully />}
                  path="pickedup"
                />
                <Route
                  element={<ProductReturnedSuccessfully />}
                  path="returned"
                />
              </Route>

              <Route path="/general_job">
                <Route path="create">
                  <Route element={<CreateJobNotification />} index />
                  <Route element={<EditWorkOrderStatus />} path="edit" />
                  <Route element={<PreviewFileCreate />} path="preview" />
                </Route>

                <Route path="follow">
                  <Route element={<FollowStatusService />} index />
                </Route>
              </Route>

              <Route path="/installation_work">
                <Route path="record">
                  <Route element={<Installation />} index />
                  <Route element={<PreviewInstallationWork />} path="preview" />
                </Route>

                <Route path="check">
                  <Route element={<CheckReceiveNotifications />} index />
                  <Route element={<PreviewCheckReceive />} path="sub" />
                </Route>
                <Route path="issue">
                  <Route element={<IssueInstallationWorkOrder />} index />
                </Route>
                <Route path="return">
                  <Route element={<ReturnPropertyInstallationWorkOrder />} index />
                  <Route element={<ReturnPropertyInstallationWorkOrderDetail />} path=":id" />

                </Route>

              </Route>

              <Route path="/MA_service">
                <Route element={<MAServiceContract />} index />
                <Route element={<ImportKeepFile />} path="preview" />
                <Route element={<AddMAServiceContract />} path="create" />
                <Route element={<EditMAServiceContract />} path=":id" />
              </Route>

              <Route path="/PM_work">
                <Route path="bind">
                  <Route element={<BindingPMServiceContract />} index />
                  <Route
                    element={<AddBindingPMServiceContract />}
                    path="create"
                  />
                  <Route
                    element={<AddSubBindingPMServiceContract />}
                    path="create/sub"
                  />
                  <Route
                    element={<EditBindingPMServiceContract />}
                    path="edit"
                  />
                  <Route
                    element={<EditBindingPMServiceContract />}
                    path=":id"
                  />
                  <Route
                    element={<DeleteBindingPMServiceContract />}
                    path="delete"
                  />
                  <Route
                    element={<CopyBindingPMServiceContract />}
                    path="copy"
                  />
                </Route>

                <Route path="create">
                  <Route element={<CreatePlanPM />} index />
                  <Route element={<AddCreatePlanPM />} path="create" />
                  <Route element={<EditCreatePlanPM />} path=":id" />
                  <Route element={<PreviewCreatePlanPM />} path="preview" />
                  <Route
                    element={<PreviewCreatePlanPM />}
                    path="create/preview"
                  />
                </Route>
                <Route path="plan">
                  <Route element={<PlanPM />} index />
                  <Route element={<EditPlanPM />} path=":id" />
                </Route>
                <Route path="adjust">
                  <Route element={<AdjustPlan />} index />
                </Route>
                <Route path="follow">
                  <Route element={<FollowPM />} index />
                </Route>
              </Route>

              <Route path="/repair_work">
                <Route path="history">
                  <Route element={<CheckCustomerHistory />} index />
                  <Route element={<PreviewRepairNotify />} path="preview" />
                </Route>
                <Route path="record">
                  <Route element={<RecordRepairNotification />} index />
                  <Route
                    element={<PreviewRepairNotification />}
                    path="preview"
                  />
                </Route>
                <Route path="issue">
                  <Route element={<IssueWorkOrderRepair />} index />
                  <Route element={<EditRepairWorkOrders />} path="edit" />
                  <Route element={<PreviewRepairWorkOrder />} path="preview" />
                </Route>
                <Route path="follow">
                  <Route element={<FollowRepairStatus />} index />
                </Route>
              </Route>

              <Route path="/service_work">
                <Route path="planning">
                  <Route element={<HeadEventPlanning />} index />
                  <Route element={<EditEventPlanningDetail />} path=":id" />
                  <Route
                    element={<EventPlanningDetail />}
                    path="EventplaningDetails"
                  />
                  <Route element={<ImportHeadEventPlanning />} path="import" />
                  <Route element={<CheckeQuipment />} path="check" />
                  <Route element={<WorkCalendar />} path="calendar" />
                  <Route element={<PlanningPreview />} path="preview" />
                </Route>
                <Route path="acceptance">
                  <Route element={<JobAcceptanceTeam />} index />
                  <Route element={<TeamDetailEdit />} path=":id" />
                  <Route element={<TeamPreview />} path="preview" />
                  <Route element={<SummaryEquipment />} path="equipment" />
                  <Route element={<ImportEquipment />} path="equipment/import" />
                  <Route element={<PreviewEquipment />} path="equipment/preview" />
                  <Route path="customer">
                    <Route element={<ContactCustomer />} index />
                    <Route element={<PageAddCustomer />} path="add" />
                    <Route element={<EditCustomer />} path=":id" />
                  </Route>
                  <Route element={<PageCheckIn />} path="checkin" />
                </Route>
                <Route path="perform">
                  <Route element={<PerformServiceRequest />} index />
                  <Route element={<DetailPerform />} path=":seq_no" />
                  <Route path="close">
                    <Route element={<DetailCloseJob />} index />

                  </Route>
                  <Route element={<ReportPage />} path="report" />
                  <Route element={<DataServiceReport />} path="report/view" />
                  <Route element={<AddReport />} path="report/add" />
                  <Route element={<EditReport />} path="report/:id" />
                  <Route element={<PreviewReportPage />} path="report/preview" />
                </Route>
                <Route path="return_equipment">
                  <Route element={<ReturnEquipmentParts />} index />
                  <Route element={<EditReturnEquipment />} path="edit" />
                  <Route element={<PreviewReturnEquipment />} path="preview" />
                </Route>
                <Route path="expenses">
                  <Route element={<ExpensesDuringWork />} index />
                  <Route element={<AddExpense />} path="add" />
                  <Route element={<EditExpense />} path=":id" />
                </Route>
                <Route path="delivery">
                  <Route element={<DeliveryDocuments />} index />
                  <Route element={<AddDocument />} path="add" />
                  <Route element={<EditDeliveryDocuments />} path=":id" />
                </Route>
              </Route>

              <Route path="reimbursement_refund">
                <Route element={<RequestReimbursementRefund />} index />
                <Route
                  element={<PreviewReimbursementRefund />}
                  path="preview"
                />
              </Route>

              <Route element={<Report />} path="/report" />
              <Route element={<Administrator />} path="/administrator" />
            </Route>

            <Route element={<Login />} path="/login" />
            <Route element={<NotFound />} path="*" />
          </Routes>
        </HelmetProvider>
      </AppContextProvider>
    </BrowserRouter>
  );
}

export default App;
